// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"style_spinnerContainer__yI6HS","relativeContainer":"style_relativeContainer__rQN0C"};